import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import classNames from 'classnames';
import {
    compose,
    withFieldSync,
    withFieldValidation,
    withFieldToken,
  } from '@formatic/sdk';

import {DropDown,Label,FieldDescription,DropdownNative} from './Components';
import { noop } from 'lodash';

const anzsic_code_path = "https://djpr.transformd.com/anzsic_codes.json";
const classTitleSearchTrigger = "5f2bab3932bbd9008950bf96";
const codeFieldId = "5f2bb852cc9534003146a279";

const mobileAndTabletcheck = () => {
    let check = false;
    const isMobile = function(a) {
      if (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(a)) {
        check = true;
      }
    };
    isMobile(window.opera || window.navigator.userAgent || window.navigator.vendor);
    return check;
};
    
class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.debouncedValidate = debounce(props.validate, 500);

        this.state = {
            anzList: [],
            anzOption: [],
            industry: null
        };
    }

    lookupClassTitle = (filterValue, persistDefaultValue = false) => {
        const {anzList} = this.state;
        const classTitle =  anzList
            .filter( ({industry}) => industry === filterValue )
            .map( ({title}) => title);

        if(!persistDefaultValue)
        {
            this.onChange();
        }
        this.setState({
            anzOption: classTitle,
            industry: filterValue
        })
    }

    lookupClassTitleDebounce = debounce(this.lookupClassTitle,600);

    fetchAnzList = () => {
        fetch(anzsic_code_path)
            .then(ret=>ret.json())
            .then(ret=>{
                this.setState({
                    anzList: ret
                })
            })
    }

    componentDidMount = () =>{
        const {getData} = this.props;
        const emitter = getData().getEmitter();

        setTimeout(() => {
            const existingValue = getData().getFieldValue(classTitleSearchTrigger);
            if (existingValue !== null && existingValue.length > 0) {
                this.lookupClassTitleDebounce(existingValue, true);
            }
         }, 250)

        this.fetchAnzList();

        const industry = getData().getFieldValue(classTitleSearchTrigger);
        this.lookupClassTitleDebounce(industry,true);

        emitter.on('ValueChanged',({fieldID,newValue})=>{
            if(classTitleSearchTrigger === fieldID)
            {
                this.lookupClassTitleDebounce(newValue);
            }
        })

    }

    setAnzCode = (classTitle ) => {
        const {anzList, industry: industryName} = this.state;
        const {getData} = this.props;

        const anzCode =  anzList
            .find(
                ({industry,title}) => industryName === industry && title === classTitle
            );

        const code = get(anzCode, "code", null);
        if(code === null)
        {
            return false;
        }

        getData().setFieldValue(codeFieldId, code);
        return true;
    }

    onChange = (value ='') => {
        this.setAnzCode(value);
        this.props.changeValue(value);
        if(value !== ''){
            this.debouncedValidate();
        }
    }

    onNativeChange = (e) => {
        this.onChange(e.target.value);
    }

    render()
    {
        const {value,attributes,errorMessage,fieldId} = this.props;
        const {description, label, class:className, mobileUseNative } = attributes;

        const {anzOption} = this.state;
        const hasError = !isEmpty(errorMessage);
        const isValid = !isEmpty(value);
        const renderNative = mobileUseNative && mobileAndTabletcheck();
        const nativeValue = !isEmpty(value) && value;
        
        return <div className={classNames("formatic-field-container",{
            [className]: className
        })}>
            <div className={ classNames("formatic-field-container__field")}>
                <Label
                    labelFor={fieldId}
                    label={label}
                    className="formatic-label formatic-field-label formatic-dropdown__label"
                />
                {
                    description!==null && <FieldDescription className="formatic-ds-component__container--description" description={description} />
                }
                <div className={ classNames("formatic-dropdown",{
                        "formatic-field-valid": isValid,
                        "formatic-field-error": hasError
                    })}
                >
                    {
                        renderNative && <DropdownNative
                            options={anzOption}
                            onChange={this.onNativeChange}
                            value={nativeValue}
                            disabled={anzOption.length === 0}
                            placeholder='Please select'
                        />
                    }
                    {
                        !renderNative && <DropDown 
                            options={anzOption} 
                            onChange={this.onChange} 
                            value={value} 
                            disabled={anzOption.length === 0}
                        />
                    }
                </div>
                {
                errorMessage
                }
            </div>
        </div>
    }
}

CustomDropdown.validator = (value, ...args) => {
    const [,,props] = args;
    const {attributes:{ required, requiredMessage }} = props;

    const result = {
        isValid:true,
        inputError: null,
    }

    if(!required){
        return { ...result, displayErrorMessage:result.inputError };
    }

    if(isEmpty(value)){
        result.isValid = false;
        result.inputError = requiredMessage;
    }

    return {...result,displayErrorMessage: result.inputError};
}


CustomDropdown.propTypes = {
    getData: PropTypes.func,
    changeValue: PropTypes.func,
    attributes: PropTypes.shape({
        label: PropTypes.string,
        description: PropTypes.string,
        className: PropTypes.string,
        fieldID: PropTypes.string,
        mobileUseNative: PropTypes.bool
    })
}

CustomDropdown.defaultProps = {
    getData: noop,
    changeValue: noop,
    attributes: {
        label: null,
        description: null,
        className: null,
        fieldID: null,
        mobileUseNative: true
    },
}

export default compose(
    withFieldSync,
    withFieldValidation,
    withFieldToken(['attributes.label', 'attributes.description']),
  )(CustomDropdown);
